import { createTheme } from '@mui/material/styles';
import { Components } from '@mui/material/styles/components';
import { ControllerButtonColor } from '../../palette';
import { ControllerFont } from '../../fonts';

const theme = createTheme();

export const ButtonComponent: Components = {
  MuiButton: {
    styleOverrides: {
      root: {
        borderRadius: 2,
        textTransform: 'none',
      },
      sizeLarge: {
        padding: theme.spacing(1.25, 2),
        ...ControllerFont.Text500M,
      },
      sizeMedium: {
        padding: theme.spacing(1),
        ...ControllerFont.Text400M,
      },
      sizeSmall: {
        fontSize: 16,
        height: 16,
        lineHeight: '16px',
        padding: theme.spacing(0.25),
        width: 16,
      },
      contained: {
        boxShadow: 'none',
        '&:hover': {
          boxShadow: 'none',
        },
        //
        // mason classes
        //
        '&.MasonButtonError': {
          backgroundColor: String(ControllerButtonColor.ContainedErrorDefaultBg),
          color: String(ControllerButtonColor.ContainedErrorDefaultFg),
          '&:disabled': {
            backgroundColor: String(ControllerButtonColor.ContainedErrorDisabledBg),
            color: String(ControllerButtonColor.ContainedErrorDisabledFg),
          },
          '&:hover': {
            backgroundColor: String(ControllerButtonColor.ContainedErrorHoverBg),
            color: String(ControllerButtonColor.ContainedErrorHoverFg),
          },
        },
      },
      containedPrimary: {
        backgroundColor: String(ControllerButtonColor.ContainedPrimaryDefaultBg),
        color: String(ControllerButtonColor.ContainedPrimaryDefaultFg),
        '&:disabled': {
          backgroundColor: String(ControllerButtonColor.ContainedPrimaryDisabledBg),
          color: String(ControllerButtonColor.ContainedPrimaryDisabledFg),
        },
        '&:hover': {
          backgroundColor: String(ControllerButtonColor.ContainedPrimaryHoverBg),
          color: String(ControllerButtonColor.ContainedPrimaryHoverFg),
        },
      },
      containedSecondary: {
        backgroundColor: String(ControllerButtonColor.ContainedSecondaryDefaultBg),
        color: String(ControllerButtonColor.ContainedSecondaryDefaultFg),
        '&:disabled': {
          backgroundColor: String(ControllerButtonColor.ContainedSecondaryDisabledBg),
          color: String(ControllerButtonColor.ContainedSecondaryDisabledFg),
        },
        '&:hover': {
          backgroundColor: String(ControllerButtonColor.ContainedSecondaryHoverBg),
          color: String(ControllerButtonColor.ContainedSecondaryHoverFg),
        },
      },
      outlinedPrimary: {
        backgroundColor: String(ControllerButtonColor.OutlinedPrimaryDefaultBg),
        color: String(ControllerButtonColor.OutlinedPrimaryDefaultFg),
        '&:disabled': {
          backgroundColor: String(ControllerButtonColor.OutlinedPrimaryDisabledBg),
          color: String(ControllerButtonColor.OutlinedPrimaryDisabledFg),
        },
        '&:hover': {
          backgroundColor: String(ControllerButtonColor.OutlinedPrimaryHoverBg),
          color: String(ControllerButtonColor.OutlinedPrimaryHoverFg),
        },
      },
      outlinedSecondary: {
        backgroundColor: String(ControllerButtonColor.OutlinedSecondaryDefaultBg),
        color: String(ControllerButtonColor.OutlinedSecondaryDefaultFg),
        '&:disabled': {
          backgroundColor: String(ControllerButtonColor.OutlinedSecondaryDisabledBg),
          color: String(ControllerButtonColor.OutlinedSecondaryDisabledFg),
        },
        '&:hover': {
          backgroundColor: String(ControllerButtonColor.OutlinedSecondaryHoverBg),
          color: String(ControllerButtonColor.OutlinedSecondaryHoverFg),
        },
      },
      textPrimary: {
        backgroundColor: String(ControllerButtonColor.TextPrimaryDefaultBg),
        color: String(ControllerButtonColor.TextPrimaryDefaultFg),
        '&:disabled': {
          backgroundColor: String(ControllerButtonColor.TextPrimaryDisabledBg),
          color: String(ControllerButtonColor.TextPrimaryDisabledFg),
        },
        '&:hover': {
          backgroundColor: String(ControllerButtonColor.TextPrimaryHoverBg),
          color: String(ControllerButtonColor.TextPrimaryHoverFg),
        },
      },
      textSecondary: {
        backgroundColor: String(ControllerButtonColor.TextSecondaryDefaultBg),
        color: String(ControllerButtonColor.TextSecondaryDefaultFg),
        '&:disabled': {
          backgroundColor: String(ControllerButtonColor.TextSecondaryDisabledBg),
          color: String(ControllerButtonColor.TextSecondaryDisabledFg),
        },
        '&:hover': {
          backgroundColor: String(ControllerButtonColor.TextSecondaryHoverBg),
          color: String(ControllerButtonColor.TextSecondaryHoverFg),
        },
      },
    },
    variants: [
      {
        props: { variant: 'underline', color: 'primary' },
        style: {
          backgroundColor: String(ControllerButtonColor.UnderlinePrimaryDefaultBg),
          border: 'none',
          borderRadius: 0,
          color: String(ControllerButtonColor.UnderlinePrimaryDefaultFg),
          '&:disabled': {
            backgroundColor: String(ControllerButtonColor.UnderlinePrimaryDisabledBg),
            color: String(ControllerButtonColor.UnderlinePrimaryDisabledFg),
          },
          '&:hover': {
            backgroundColor: String(ControllerButtonColor.UnderlinePrimaryHoverBg),
            borderBottom: `1px solid ${String(ControllerButtonColor.UnderlinePrimaryHoverFg)}`,
            color: String(ControllerButtonColor.UnderlinePrimaryHoverFg),
          },
        },
      },
      {
        props: { variant: 'underline', color: 'secondary' },
        style: {
          backgroundColor: String(ControllerButtonColor.UnderlineSecondaryDefaultBg),
          border: 'none',
          color: String(ControllerButtonColor.UnderlineSecondaryDefaultFg),
          '&:disabled': {
            backgroundColor: String(ControllerButtonColor.UnderlineSecondaryDisabledBg),
            color: String(ControllerButtonColor.UnderlineSecondaryDisabledFg),
          },
          '&:hover': {
            backgroundColor: String(ControllerButtonColor.UnderlineSecondaryHoverBg),
            borderBottom: `1px solid ${String(ControllerButtonColor.UnderlineSecondaryHoverFg)}`,
            color: String(ControllerButtonColor.UnderlineSecondaryHoverFg),
          },
        },
      },
    ],
  },
};
